import { Chart } from 'chart.js';
const template = require('./mana-curve.tpl').default;

export default DomClass(template, function() {

	var manacost = this.data || {
		curve: [],
		cmc: 0,
		colors: [],
		median: 0
	};

	this.median = manacost.median;

	var colorDataset = function(data, name, hexColor) {
		return {
			label: name + " Symbols",
			stack: "colors",
			yAxisID: 'symbols',
			backgroundColor: hexColor,
			borderColor: 'black',
			borderWidth: 1,
			data: data
		};
	};

	var manachartdata = {
		labels: ['0', '1', '2', '3', '4',' 5', '6', '7', '8+'],
		datasets: [
			{
				label: "Cards",
				stack: "CMC",
				yAxisID: 'cards',
				backgroundColor: 'violet',
				borderColor: 'black',
				borderWidth: 1,
				data: manacost.curve
			},
			colorDataset(manacost.colors.R, 'Red', '#c33'),
			colorDataset(manacost.colors.G, 'Green', '#3c3'),
			colorDataset(manacost.colors.U, 'Blue', '#33d'),
			colorDataset(manacost.colors.B, 'Black', '#333'),
			colorDataset(manacost.colors.W, 'White', '#eee')
		]
	};

	var ctx = this.managraph.getContext('2d');
	var manachart = new Chart(ctx, {
		type: 'bar',
		data: manachartdata,
		options: {
			legend: {
				display: false,
			},
			tooltips: {
				mode: 'index',
				intersect: true
			},
			scales: {
				xAxes: [{
					scaleLabel: { display: false, labelString: 'CMC' },
					stacked: true
				}],
				yAxes: [{
					scaleLabel: { display: true, labelString: 'Cards'},
					id: 'cards',
					position: 'left',
					stacked: true
				},
				{
					scaleLabel: { display: true, labelString: 'Symbols'},
					id: 'symbols',
					position: 'right',
					stacked: true
				}]
			}
		}
	});

});
